import React, { useState, useRef } from "react";
import { Button, message } from "antd";
import { SoundOutlined } from "@ant-design/icons";

interface AudioPlayButtonProps {
  voiceUrl: string;
  recordId: string;
}

function AudioPlayButton({ voiceUrl, recordId }: AudioPlayButtonProps) {
  const [playingAudioId, setPlayingAudioId] = useState<string | null>(null);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const handlePlayAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }

    if (playingAudioId === recordId) {
      setPlayingAudioId(null);
      return;
    }

    const audio = new Audio(voiceUrl);
    audioRef.current = audio;
    setPlayingAudioId(recordId);

    audio.play().catch((error) => {
      console.error("🚀 ~ handlePlayAudio ~ error:", error);
      message.error("音频播放失败");
      setPlayingAudioId(null);
    });

    audio.onended = () => {
      setPlayingAudioId(null);
    };

    audio.onerror = () => {
      message.error("音频播放失败");
      setPlayingAudioId(null);
    };
  };

  return (
    <Button
      type="text"
      icon={<SoundOutlined />}
      onClick={handlePlayAudio}
      style={{
        color: playingAudioId === recordId ? "#1890ff" : undefined,
      }}
    />
  );
}

export default AudioPlayButton;
